<script>
import AdminLayout from '@layouts/admin-main'
import ClientList from '@components/admin/oauth2-client-list'

export default {
  page: {
    title: 'Admin::ClientList',
    meta: [{ name: 'description', content: 'Admin::ClientList' }],
  },
  components: { AdminLayout, ClientList },
}
</script>

<template>
  <AdminLayout>
    <ClientList></ClientList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
